import { render, staticRenderFns } from "./totalScoreDistribution.vue?vue&type=template&id=9721e64c&scoped=true"
import script from "./totalScoreDistribution.vue?vue&type=script&lang=js"
export * from "./totalScoreDistribution.vue?vue&type=script&lang=js"
import style0 from "./totalScoreDistribution.vue?vue&type=style&index=0&id=9721e64c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9721e64c",
  null
  
)

export default component.exports